export const DASHBOARD_CAMPAIGN_STATS_REQUEST = 'DASHBOARD_CAMPAIGN_STATS_REQUEST';
export const DASHBOARD_CAMPAIGN_STATS_SUCCESS = 'DASHBOARD_CAMPAIGN_STATS_SUCCESS';
export const DASHBOARD_CAMPAIGN_STATS_FAIL = 'DASHBOARD_CAMPAIGN_STATS_FAIL';
export const DASHBOARD_FORTIPHISH_DATA_REQUEST = 'DASHBOARD_FORTIPHISH_DATA_REQUEST';
export const DASHBOARD_FORTIPHISH_DATA_SUCCESS = 'DASHBOARD_FORTIPHISH_DATA_SUCCESS';
export const DASHBOARD_FORTIPHISH_DATA_FAIL = 'DASHBOARD_FORTIPHISH_DATA_FAIL';